module.exports = __webpack_public_path__ + "media/application/images/svgs/smartphone-d6096372238a47fa9e2642c90f0d55c3.svg";